import { useState } from 'react';
import { ImageList, ImageListItem } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import { CustomDialog } from './customDialog/CustomDialog';
import fileDownload from 'js-file-download';

pdfjs.GlobalWorkerOptions.workerSrc =
    `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function DocumentViewerBase64({ data, setOpenDlg, download = false, width = "md", fullWidth = false }) {

    const [open, setOpen] = useState(true);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const handleClose = () => {
        setOpen(false);
        setOpenDlg(false);
    };

    const handleDocumentLoad = ({ numPages }) => {
        setNumPages(numPages);
        setPageNumber(1);
    };

    const handleClickBackDrop = () => {
        handleClose();
    };

    const handleDownload = () => {
        // Convierte el base64 en un blob para descargar
        const byteCharacters = atob(data.archivo);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const documento = new Blob([byteArray], { type: data.contentType });
        const fileName = data.titulo;

        fileDownload(documento, fileName);
    };

    // Construimos el formato base64 para visualizar el archivo
    const base64File = `data:${data.contentType};base64,${data.archivo}`;

    return (
        <>
            <CustomDialog
                maxWidth={width}
                width={width}
                open={open}
                onBackdropClick={handleClickBackDrop}
                onCancel={handleClose}
                onAccept={(download) ? handleDownload : ''}
                cancelText='Cerrar'
                acceptText='Descargar'
                title={`Visualización de Documento - ${data.titulo}`}
                fullWidth={fullWidth}
            >
                {/* IMAGEN */}
                {((data.extension.toLowerCase() === '.jpeg') ||
                    (data.extension.toLowerCase() === '.jpg') ||
                    (data.extension.toLowerCase() === '.jfif') ||
                    (data.extension.toLowerCase() === '.png')) &&
                    <ImageList cols={1} rows={1}>
                        <ImageListItem key={data.titulo}>
                            <img src={base64File} alt={data.titulo} />
                        </ImageListItem>
                    </ImageList>
                }
                {/* PDF */}
                {data.extension.toLowerCase() === '.pdf' &&
                    <Document
                        file={base64File}
                        onLoadSuccess={handleDocumentLoad}
                    >
                        {Array.from(
                            new Array(numPages),
                            (el, index) => (
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    width={800}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={false}
                                />
                            )
                        )}
                    </Document>
                }
                {/* AGREGAR PARA TIPO DOC */}
                {((data.extension.toLowerCase() === '.docx') || (data.extension.toLowerCase() === '.doc')) &&
                    <h3>El tipo de archivo no permite una visualización previa.</h3>
                }
            </CustomDialog>
        </>
    );
};